import { ReactComponent as CardIcon } from 'assets/icons/base/card-icon.svg';
import Plus24Icon from 'assets/icons/base/plus24-icon.svg';
import ApplePayLogo from 'assets/images/1xbet/apple-pay.svg';
import GPayLogo from 'assets/images/1xbet/gpay.png';
import MSLogo from 'assets/images/1xbet/master-card.svg';
import PCIDSSLogo from 'assets/images/1xbet/pci-dss.svg';

export const BaseIcons = {
  CardIcon,
  Plus24Icon,
};

export const MerchImagesList = [
  { id: 1, src: ApplePayLogo, alt: 'applt-pay' },
  { id: 2, src: GPayLogo, alt: 'g-pay' },
  { id: 3, src: PCIDSSLogo, alt: 'pcs-dss' },
  { id: 5, src: MSLogo, alt: 'master-card' },
];
